import { useSelector } from "react-redux";
import { Box } from "@remo-co/ui-core/src/components/Box";
import { Toolbar } from "@remo-co/ui-core/src/components/Toolbar";
import {
  CameraButton,
  LeaveEventButton,
  MicrophoneButton,
  RaiseHandButton,
  ScreenSharingButton,
} from "modules/eventButtons";
import { HelpChatButton } from "modules/helpChat";
import EmojiButtonContainer from "modules/emoji/EmojiButtonContainer/EmojiButtonContainer";
import { ClosedCaptionButton } from "modules/transcription";
import { selectIsMobile } from "modules/deviceInfo";
import { Chat as ChatBubble } from "@remo-co/ui-core/src/icons/Chat";
import { useI18n } from "i18n";
import { useDevices } from "modules/audioVideo/hooks";
import { useStyles } from "./styles";
import AudienceViewIcon from "./AudienceViewIcon";
import { RightPanelTabButton } from "./RightPanelTabButton";

const AttendeeButtons = (): JSX.Element => {
  const { t } = useI18n(["common"]);
  const styles = useStyles();
  const isMobileView = useSelector(selectIsMobile);
  const { hasPublishingPermissions } = useDevices();

  return (
    <div className={styles.container}>
      <Box display="flex" left={10} alignItems="center">
        <Box className={styles.hideOnMobile} marginRight={1}>
          <HelpChatButton
            darkMode={false}
            color="dark"
            variant="ghost"
            className={styles.helpChatButton}
          />
        </Box>
        {!isMobileView && (
          <Box marginRight={1}>
            <AudienceViewIcon />
          </Box>
        )}
      </Box>

      <Toolbar disableGutters className={styles.toolbar}>
        {hasPublishingPermissions && (
          <>
            <CameraButton darkMode />
            <MicrophoneButton darkMode />
            <ScreenSharingButton darkMode />
          </>
        )}
        {isMobileView && (
          <>
            <AudienceViewIcon />
            <RightPanelTabButton
              text={t("common:participants")}
              icon={<ChatBubble />}
            />
          </>
        )}
        <RaiseHandButton />
        <ClosedCaptionButton darkMode />
        <LeaveEventButton darkMode />
      </Toolbar>
      <Box display="flex" justifyContent="flex-end">
        {!isMobileView && <EmojiButtonContainer />}
      </Box>
    </div>
  );
};

export default AttendeeButtons;
